/**
 * @Author wutao
 * @description 线下培训班级新增编辑页面
 * @Date 2020/2/21
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Form, message, Popconfirm, Spin, Upload} from "antd";
import { WizTableForm } from '@/containers/common'
import { WizCheckbox, WizInputNumber } from 'wiz-components';
const offlineProgramConfig = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 ,category:0} });
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1,roleConfig: "teacherRole" } });
let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin,WizInput, WizRow,WizCol,WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip } = component_tool;
let Item = Form.Item;
let Option = WizSelect.Option;
let {Session} = utils_tool;

class ClassDetail extends WizContainer {

  componentName = 'ClassDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/face/classList/classDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('classDetailRecord', initialValue)
      } else {
        initialValue = Session.get('classDetailRecord') || {};
      }
    }else if (history.location && history.location.pathname === '/face/classList/classDetailCopy'){
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        initialValue.id=null;
        // initialValue.type=null;
        Session.set('classDetailRecord', initialValue)
      } else {
        initialValue = Session.get('classDetailRecord') || {};
      }
    }
    this.state = {
      address: initialValue && initialValue.address ? initialValue.address : "",
      classDateFlag : initialValue && initialValue.startDate ? false : true,
      classStartDate : initialValue && initialValue.startDate ? initialValue.startDate  : "",
      classEndDate : initialValue && initialValue.endDate ? initialValue.endDate : "",
      classRoomShow : initialValue && initialValue.type===0 ? true : false,
     // hasTeamState: initialValue && initialValue.hasTeam === 0 ? 0 : 1,
     hasTeamState: initialValue && initialValue.hasTeam === 1 ? 1 : 0,
      hasApplyTimeState: initialValue && initialValue.hasApplyTime === 1 ? 1 : 0,
    };
    this.initialValue = initialValue;
    this.initialValue.offlineProgramInfo = [];
    this.initialValue.personInfo = [];
    this.clearWizCallBack = [];
  }

  _componentDidMount() {
    const {history} = this.props;
    if (this.initialValue && this.initialValue.programId){
      this.getOfflineProgramInfo();
    }
    if (this.initialValue && this.initialValue.lectureIds){
      this.getPersonInfoByPersonIdList()
    }
  }

  propsAndStateOnChange = {
    addClass: this._addClassOver.bind(this),
    updateClass: this._updateClassOver.bind(this),
    offlineProgramInfo:this._getOfflineProgramInfoOver.bind(this),
    personInfo: this._getPersonInfoOver.bind(this),
  };


  /**
   * 线下培训班级新增成功返回原页面，失败弹出提示
   */
  _addClassOver(nextProps, nextState) {
    if (nextProps.addClass.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/face/classList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addClass.msg);
    }
    return true;
  }

  /**
   * 线下培训班级修改成功返回原页面，失败弹出提示
   */
  _updateClassOver(nextProps, nextState) {
    if (nextProps.updateClass.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/face/classList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateClass.msg);
    }
    return true;
  }

  /**
   * 将查询到的线下培训课程选项加载到记录中
   */
  _getOfflineProgramInfoOver(nextProps, nextState) {
    let offlineProgramInfo = nextProps.offlineProgramInfo.data;
    const {id} = offlineProgramInfo;
    if (nextProps.offlineProgramInfo.code == 1 && id && id>0) {
      this.initialValue.offlineProgramInfo = [offlineProgramInfo];
    }else {
      this.initialValue.programId = null;
    }
    return true;
  }

  /**
   * 将查询到的人员选项加载到记录中
   */
  _getPersonInfoOver(nextProps, nextState) {
    let personInfo = nextProps.personInfo.data;
    if (nextProps.personInfo.code == 1 && personInfo && personInfo.length) {
      this.initialValue.personInfo = personInfo;
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'classDate' && value != null && value != undefined) {
        fitterValues['startDate'] = value[0].format("YYYY-MM-DD HH:mm:ss");
        fitterValues['endDate'] = value[1].format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
      if(key === 'conAgreement'){
        if(value!=0){
          fitterValues['conAgreement']=1
        }else{
          fitterValues['conAgreement']=0
        }
      }
      if(key === 'secProtocol'){
        if(value!=0){
          fitterValues['secProtocol']=1
        }else{
          fitterValues['secProtocol']=0
        }
      }
      // if(key === 'hasTeam'){
      //   if(value!=0){
      //     fitterValues['hasTeam']=1
      //   }else{
      //     fitterValues['hasTeam']=0
      //   }
      // }
      if(key === 'hasQr'){
        if(value && value.indexOf(0) >= 0 ){
          fitterValues['hasQr']=1
        }else{
          fitterValues['hasQr']=0
        }
      }
      if(key === 'hasApplyTime'){
        if(value!=0){
          fitterValues['hasApplyTime']=1
        }else{
          fitterValues['hasApplyTime']=0
        }
      }
      // if(key === 'trainSiteId'){
      //   fitterValues['trainSiteId']=fitterValues['trainSiteId'][0]
      // }
    });
    if(fitterValues.type===1 && fitterValues.trainSiteId){
      fitterValues.trainSiteId = null;
    }
    fitterValues['hasTeam']=0
    return fitterValues;
  };

  /**
   * 处理表单提交事件
   */
   handleSubmit = e => {
    // e.preventDefault();
    this.formData.validateFields((err, values) => {
      if (!err) {
        this._saveClass(values);
      }
    });
  };

  /**
   * 保存/更新 线下培训课程信息
   * @param values
   * @private
   */
  _saveClass(values) {
    const {history} = this.props;
    let apiPath = "classManagement/add";
    let payloadKey = "addClass";
    if (history.location && history.location.pathname === '/face/classList/classDetailUpd') {
      apiPath = "classManagement/update";
      payloadKey = "updateClass";
    }
    let fitterValues = this.fitterFieldsValue(values);
    if(fitterValues.lectureIds && fitterValues.lectureIds.length>10){
        wizNotice.warn("讲师限制10人,请确认后重试");
        return ;
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  };

  /**获取对应的线下培训课程数据，线下培训课程选择组件需要显示默认值 */
  getOfflineProgramInfo() {
    this.doAction({
      path: 'offlineProgramManagement/getOfflineProgram',
      payload: {
        key: 'getOfflineProgramInfo',
        apiParams: {
          id: this.initialValue.programId,
        }
      }
    });
  }

  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList() {
    this.doAction({
      path: 'personManage/getPersonInfoByPersonIdList',
      payload: {
        key: 'getPersonInfoByPersonIdList',
        apiParams: {
          personIdList: this.initialValue.lectureIds,
        }
      }
    });
  }

  /**
   * 重置表单
   */
   handleReset = () => {
     this.formData.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _onClearWiz2(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
      this.cleanStudent = callback
    }
  }

  /**
   * 表单提交按钮
   */
   _submit() {
      return (
              <div style={{textAlign: 'center'}}>
                <WizButton style={{marginLeft: 20}} title="保存" type="primary" htmlType="submit">保存</WizButton>
                <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>重置</WizButton>
              </div>
           
      )
    
  }

  _render() {
    const { classManagementLoading, offlineProgramManagementLoading, personManageLoading } = this.props;
    let initialValue = this.initialValue;
    let cardTitle = '新增';
    const {id, status, programId, trainSiteId,trainSiteName, startDate, endDate, offlineProgramInfo,type} = initialValue;
    let initialStatus = 1;
    let initialProgramId = null;
    let initialTrainSiteId = null;
    let initialTrainSiteName = null;
    let initialOfflineProgramInfo = [];
    let initialClassDate = [];
    let initialClassType = undefined;
    if (id){
      cardTitle = '编辑';
      initialStatus = status;
    }
    if (programId) {
      initialProgramId = programId;
    }
    if (offlineProgramInfo[0]) {
      initialOfflineProgramInfo = offlineProgramInfo;
    }
    if (trainSiteId) {
      initialTrainSiteId = trainSiteId;
    }
    if (trainSiteName) {
      initialTrainSiteName = trainSiteName;
    }
    if (type || type===0) {
      initialClassType = type;
    }
    if ( startDate && endDate) {
      initialClassDate.push(startDate);
      initialClassDate.push(endDate);
    }
    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.delFlag
        },
        name: "delFlag"
      },
      {
        title: "班级名称",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={22}>
                  {
                    getFieldDecorator('name', {
                      rules: [{required: true, message: '请输入班级名称'}],
                      initialValue: initialValue.name,
                    })(
                      <WizInput maxlength={25}
                      placeholder="请输入班级名称,长度不能超过25个字符"/>
                    )
                  }
                </WizCol>
                <WizCol span={2}>
                  <WizTooltip title={'名称限制25个字,建议命名规范:内容+岗位+班级'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 20}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: "所属课程",
        name: "programId",
        formItem: {
          ...offlineProgramConfig,
          diy: WizTableForm,
          initialValue: initialProgramId,
          initRows:initialOfflineProgramInfo,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择所属课程',
          }],
          disabled: status && status !=0 ,
        },
      },
      {
        title: '班级时间',
        name: 'classDate',
        formItem: {
          type: "date~",
          showTime: true,
          rules: [{
            required: true,
            message: '请选择班级时间'
          }],
          onChange: (form,value) => {
            this.setState({
              classDateFlag : value && value.length > 0 ? false : true,
              classStartDate : value && value.length > 0 ? value[0].format('YYYY-MM-DD HH:mm:ss') : "",
              classEndDate : value && value.length > 0 ? value[1].format('YYYY-MM-DD HH:mm:ss') : "",
             })
          },
          initialValue : initialClassDate
        },
      },
      {
        title: '班级类型',
        name: 'type',
        dict: [
          {code: 1, codeName: "线上班级"},
          {code: 0, codeName: "线下班级"}
        ],
        formItem: {
          type: 'radio',
          rules: [{
            required: true,
            message: '请选择班级类型'
          }],
          disabled: initialClassType || initialClassType===0 ? true : false,
          initialValue : initialClassType,
          onChange: (form,value,label,extra)  => {
            this.setState({
              classRoomShow: label.target.value===1 ? false : true,
              address :  ""
             })
          },
        },
      },
      this.state.classRoomShow?
      {
        title: '教室',
        name: 'trainSiteId',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            let formValue = WizTableForm.Config.trainSite(this, {
                 apiParams: { 
                  status: 0, type:0, auditType:0,allowOrder:0,dataPerms_sceneTypeIdList: [125], managerType:1,permType: 1,
                  appointmentStart:this.state.classStartDate,appointmentEnd:this.state.classEndDate 
                } 
              });
            return (
              <WizRow>
                <WizCol span={22}>
                  {
                    getFieldDecorator('trainSiteId', {
                      // rules: [{required: true, message: '教室'}],
                      initialValue: initialTrainSiteId,
                      onChange: (form,value,label,extra)  => {
                        if(value ){
                          this.setState({
                            address: value[0].trainCenterName,
                            classDateFlag : false
                         })
                        }else{
                          if(!form){
                            this.setState({
                              address: '',
                            })
                          }else{
                            this.setState({
                              address: this.initialValue.address ,
                            })
                          }
                        }
                      },
                    })(
                  <WizTableForm maxlength={25} 
                      disabled={ this.state.classDateFlag}
                      {...formValue}
                      ref={(r => this.classInfoTableForm = r)}
                      onClearWiz={this._onClearWiz2.bind(this)} 
                      initRows={[{id: initialTrainSiteId, name: initialTrainSiteName }]} 
                      rowTitle={"name"}
                      placeholder="请选择教室"/>
                    )
                  }
                </WizCol>
                <WizCol span={2}>
                  <WizTooltip title={'若选择教室,则自动生成教室预约记录'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 20}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      }:{},
      this.state.classRoomShow?
      {
        title: "培训中心",
        name: "address",
        formItem: {
          type: 'custom',
          render: () => {
            return <div>{this.state.address || ""}</div>}
        },
      }:{},
      this.state.classRoomShow?
      {
        title: '使用类型',
        name: 'useType',
        dict: [
          { code: 0, codeName: '新产品培训' },
          { code: 1, codeName: '实操培训' },
          { code: 2, codeName: '岗位培训' },
          { code: 3, codeName: '区域会议' }
        ],
        formItem: {
          type: this.state.address ? 'select' : 'hidden',
          style: { maxWidth: 300 },
          rules: [{ required: true, message: '请选择使用类型' }],
          initialValue: initialValue.useType ? initialValue.useType : 0,
        }
      }:{},
      {
        title: "报名时间限制",
        name: "hasApplyTime",
        dataIndex: "hasApplyTime",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (<>
              <WizRow>
                <WizCol span={2}>
                  {getFieldDecorator('hasApplyTime', {
                    initialValue: initialValue.hasApplyTime === 1 ? [1]:[0],
                  })(
                    <WizCheckbox.Group>
                        <WizCheckbox value={1}
                        onChange={(form, value, label, extra) => {
                        this.setState({
                          hasApplyTimeState: form.target.checked ? 1 : 0
                        })
                      }}
                        ></WizCheckbox>
                    </WizCheckbox.Group>,
                    )}
                  
                </WizCol>
              </WizRow>
            </>
            )
          }
        },
      },
      (this.state.hasApplyTimeState && this.state.hasApplyTimeState === 1) ? {
        title: "报名提前天数",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={6}>
                  {
                    getFieldDecorator('applyTime', {
                      rules: [{required: true,message:'请输入报名提前天数'}],
                      initialValue: initialValue.applyTime,
                    })(
                      <WizInputNumber maxlength={4} value min={1} max={9999}/>
                    )
                  }
                </WizCol>
              </WizRow>
            )
          }
        }
      } : {},
      {
        title: "限制人数",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={6}>
                  {
                    getFieldDecorator('limitNum', {
                      rules: [{required: true, message: '请输入限制人数'}],
                      initialValue: initialValue.limitNum,
                    })(
                      <WizInputNumber maxlength={3} min={1} max={100}
                      placeholder="请输入限制人数"/>
                    )
                  }
                </WizCol>
                <WizCol span={2}>
                  <WizTooltip title={'班级允许参加的总人数'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 20}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      // {
      //   title: "组班群聊",
      //   name: "hasTeam",
      //   dict: [{ codeName: '', code: 1 }],
      //   formItem: {
      //     type: 'checkbox',
      //     initialValue: initialValue.hasTeam === 0 ? [0]:[1],
      //     onChange:(form, value, label, extra) => {
      //       this.setState({
      //         hasTeamState: value ? value[0] : 0
      //       })
      //     }
      //   },
      // },


      // {
      //   title: "组班群聊",
      //   name: "hasTeam",
      //   dataIndex: "hasTeam",
      //   formItem: {
      //     type: 'custom',
      //     render: (record, form) => {
      //       const { getFieldDecorator } = form;
      //       return (<>
      //         <WizRow>
      //           <WizCol span={2}>
      //             {getFieldDecorator('hasTeam', {
      //               initialValue: initialValue.hasTeam === 0 ? [0]:[1],
      //             })(
      //               <WizCheckbox.Group>
      //                   <WizCheckbox value={1} 
      //                   onChange={(form, value, label, extra) => {
      //                   this.setState({
      //                     hasTeamState: form.target.checked ? 1 : 0
      //                   })
      //                 }}
      //                   ></WizCheckbox>
      //               </WizCheckbox.Group>,
      //               )}
                  
      //           </WizCol>
      //           {/* <WizCol span={22}>
      //             <span style={{color: 'red',}}>{'【若是新能源课程，无需勾选此功能】'}</span>
      //           </WizCol> */}
      //         </WizRow>
      //       </>
      //       )
      //     }
      //   },
      // },


      (this.state.hasTeamState && this.state.hasTeamState === 1) ? {
        title: "开启入店扫码",
        name: "hasQr",
        dict: [{ codeName: '', code: 0 }],
        formItem: {
          type: 'checkbox',
          initialValue: initialValue.hasQr === 1 ? [0]: null
        },
      } : {},
      {
        title: "讲师",
        name: "lectureIds",
        formItem: {
          ...userConfig,
          title: '选择讲师',
          diy: WizTableForm,
          initialValue: this.lectureIds ? this.lectureIds : initialValue.lectureIds,
          initRows: this.personInfo ? this.personInfo : initialValue.personInfo,
          selectType: 'checkbox',
          rules: [{ required: this.state.hasTeamState && this.state.hasTeamState === 1, message: '请选择讲师' }],
          onChange: (form, value, label, extra) => {
            this.lectureIds = value
            this.personInfo = label
          }
        },
      },
      {
        title: "安全协议",
        name: "secProtocol",
        dict: [{ codeName: '', code: 1 }],
        formItem: {
          type: 'checkbox',
          col: { span: 12},
          formItemLayout: {
            labelCol: {span: 18},
            wrapperCol: {span: 6}
          },
          initialValue: initialValue.secProtocol && initialValue.secProtocol==1? [1]:[0]
        },
      },
      {
        title: "保密协议",
        name: "conAgreement",
        dict: [{ codeName: '', code: 1 }],
        formItem: {
          type: 'checkbox',
          col: { span: 12},
          formItemLayout: {
            labelCol: {span: 6},
            wrapperCol: {span: 18}
          },
          initialValue: initialValue.conAgreement && initialValue.conAgreement==1? [1]:[0]
        },
      },

      {
        title: "介绍",
        name: "intro",
        formItem: {
          type: 'textarea',
          placeholder: '请输入介绍最多输入100个字符',
          maxlength:100,
          rules: [],
          initialValue: initialValue.intro
        },
      },
    ];

    let onSubmit = this._saveClass.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit: this.handleSubmit,
      record: null,
      preview: null,
      footer: null,
      formItemLayout: {
        labelCol: {span: 9},
        wrapperCol: {span: 15}
      },
      style: {maxWidth: 800}
    };

    return (
      <WizCard>
        <Spin tip={'加载中'} spinning={classManagementLoading || offlineProgramManagementLoading || personManageLoading}>
          <WizForm className={'form-inline'} {...formProps}  
          ref={r => {
            this.formData = r
          }}>
          {this._submit()}
            </WizForm>
        </Spin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classManagement,offlineProgramManagement,personManage} = state;
  const addClass = modelUtils.getModelEntity(classManagement, "addClass");
  const updateClass = modelUtils.getModelEntity(classManagement, "updateClass");
  const offlineProgramInfo = modelUtils.getModelEntity(offlineProgramManagement, "getOfflineProgramInfo");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const load = modelUtils.getLoadingState(state, ['classManagement','offlineProgramManagement','personManage']);
  return {
    addClass: addClass,
    updateClass: updateClass,
    offlineProgramInfo: offlineProgramInfo,
    personInfo: personInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ClassDetail);
